import React, {useState, useContext} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AuthContext from '../../context/authContext/authContext';
import {
    AppBar,
    Typography,
    IconButton,
    Grid,
    Menu,
    MenuItem,
    Badge
    } from '@material-ui/core';

const styles = makeStyles((theme) =>({
    nav : {
        padding : '1rem'
    }
}))


const NavBar = (props) => {
    
    const authContext = useContext(AuthContext);
    const {
            logOut,
            carrito
        } = authContext; 

    const [openMenu, setopenMenu] = useState(null);

    const classes = styles()

    const handleClick = (event) =>{
        setopenMenu(event.currentTarget)
    }
    const handleClose = () => {
        setopenMenu(null);
      };

    const cerrarSesion = () =>{
        setopenMenu(null);
        logOut();
        props.history.push('/')
    }


    return ( 
        <AppBar className={classes.nav} position="sticky">
            <Grid 
                container  
                direction="row"
                justify="space-between"
                alignItems="center">
                <Grid> 
                    <Typography component='h2' variant='h4'>
                        Bienvenido
                    </Typography>
                </Grid>
                <Grid>   
                    
                    <IconButton aria-label="delete"  color="inherit" onClick={handleClick}>
                    <Badge badgeContent={carrito ? carrito.length : 0} color="secondary">
                        <AccountCircle size='medium'/> 
                    </Badge>
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={openMenu}
                        keepMounted
                        open={Boolean(openMenu)}
                        onClose={handleClose}
                        >
                            <MenuItem >Mi Pedido</MenuItem>
                            <MenuItem onClick={cerrarSesion}>Cerrar Sesion</MenuItem>
        
                    </Menu>
                </Grid>
            </Grid>
       
            
        </AppBar>
     );
}
 
export default NavBar;